import { useContext, useEffect, useState } from 'react'
import { getLastOrder } from '#src/common/lib/get-last-order'
import { useSwitch } from '#hooks/index'
import { useAppSelector } from '#src/state/redux-hooks'
import { accountSelector } from '#src/state/account-state-slice'
import { envSelector } from '#src/state/env-state-slice'

export const useLastOrder = (
  lastOrderFlag: boolean,
  isTransactional: boolean,
  locale: string,
  fulfillingShopId: string,
  pickupTimeStart: string,
  pickupTimeEnd: string,
  orderType: string
) => {
  const [lastOrder, setLastOrder] = useState([])
  const [hasBeenAddedToBag, setHasBeenAddedToBag] = useSwitch(false)

  const { isAuthenticated } = useAppSelector(accountSelector)
  const { platformApiHost } = useAppSelector(envSelector)

  useEffect(() => {
    if (
      isAuthenticated &&
      lastOrderFlag &&
      !hasBeenAddedToBag &&
      platformApiHost &&
      isTransactional
    ) {
      getLastOrder(platformApiHost, {
        locale,
        orderDetails: {
          fulfillingShopId,
          pickupTimeStart,
          pickupTimeEnd,
          orderType
        }
      }).then(lastOrder => {
        setLastOrder(lastOrder)
      })
    }
  }, [
    isAuthenticated,
    lastOrderFlag,
    hasBeenAddedToBag,
    platformApiHost,
    isTransactional,
    locale,
    fulfillingShopId,
    pickupTimeEnd,
    pickupTimeStart,
    orderType
  ])

  return {
    lastOrder,
    hasBeenAddedToBag,
    setHasBeenAddedToBag
  }
}
